import { ServiceWorkerConfigService } from './service-worker-config.service';

export function serviceWorkerEnabled(
    serviceWorkerConfigService: ServiceWorkerConfigService,
    hasServiceWorkerApi: boolean
) {
    return hasServiceWorkerApi && serviceWorkerConfigService.config.enabled;
}
